import Vue from 'vue';
import html from '../templates/droppable-zone.html';
import '../assets/css/droppable-zone.css';
import previewService from '../js/preview-services';

export default Vue.component('dropzone', {
  template: html,
  props: ['story', 'commonPack', 'host', 'storyId'],
  data() {
    return {
      hello: 'hello',
      uploadedPhoto: []
    };
  },
  methods: {},
  mounted() {
    let that = this;
    let loaderActive = true;
    window.addEventListener('load', function () {
      that.$refs.dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        that.$refs.dropzone.style.background = 'rgba(220, 220, 220, 0.26)';
      });
      that.$refs.dropzone.addEventListener('dragenter', function (e) {
        e.preventDefault();
      });
      that.$refs.dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        let dataTransfer = e.dataTransfer;
        let files = dataTransfer.files;
        let fileType = 'File';
        for (let key in files) {
          if (Object.prototype.toString.call(files[key]).indexOf(fileType) !== -1) {
            if (files && files[key].type && files[key].type.match('image.*')) {
              that.$emit('update-loader', loaderActive);
              let data = new FormData();
              data.append('image', files[key]);
              let saveBackendResult = previewService.sendPhotoToBackend(that.$http, that.host, that.storyId, data);
              saveBackendResult
                .then((success) => {
                  that.story.data.content.push(success.body.content);
                  that.$emit('updated-story', that.story);
                  that.commonPack.push(success.body.content);
                  that.$emit('update-common', that.commonPack);
                  that.$emit('update-loader', !loaderActive);
                }, (error) => {
                  console.warn(`Error message: ${error.statusText} `, error);
                  that.$emit('update-loader', !loaderActive);
                });
            }
          }
        }
      });
    });

    window.addEventListener('drop', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #c8c8c8';
      that.$refs.dropzone.style.background = 'transparent';
    });
    window.addEventListener('dragleave', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #c8c8c8';
      that.$refs.dropzone.style.background = 'transparent';
    });
    window.addEventListener('dragover', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #3bd639';
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/droppable-zone.js